import { AppUtil, UIUtil } from 'kuaidong-lib'
import { RewardType, RewardTypeKoiFish, E_REWARD_ITEM_TYPE } from 'kuaidong-model'

export function buildRewardBtn(_type: RewardType, _splus?: boolean) {
  switch (_type) {
    case RewardType.TTB:
    case RewardType.TTP:
      return {
        action: () => {},
        btnType: 'function',
        btnLabel: '去查看',
        disabled: true,
      }

    case RewardType.Beans:
      return {
        action: () => AppUtil.jump2NativePageByName('dailyReward'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.Bottle:
      return {
        action: () => AppUtil.jump2NativePageByName('sportsShowMall'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.Medal:
      return {
        action: () => AppUtil.jump2NativePageByName('myHonor'),
        btnType: 'danger',
        btnLabel: '去查看',
        disabled: false,
      }

    case RewardType.SSplusCoupon:
      return {
        action: () => {},
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: true,
      }

    case RewardType.AvatarFrame:
      return {
        action: () =>
          AppUtil.isAppVersionHigherThan('3.0.58').then((res) => {
            if (res) {
              AppUtil.jump2NativePageByName('avatarDecoration')
            } else {
              UIUtil.checkFailed('头像框功能需升级至最新版本体验')
            }
          }),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.SportsCardHolder:
    case RewardType.SportsCardDiamond:
      return {
        action: () =>
          AppUtil.isAppVersionHigherThan('3.0.46').then((res) => {
            if (res) {
              AppUtil.jump2NativePageByName('sportsCardStore')
            } else {
              UIUtil.checkFailed('客户端版本过低，请升级')
            }
          }),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.ShellCoin:
    case RewardType.SportsShowEmoji:
    case RewardType.SportsIslandGift:
    case RewardType.SportsIslandSkin:
    case RewardType.SportsIslandVehicle:
    case RewardType.SportsIslandFurniture:
    case RewardType.SportsIslandInteractiveProps:
      return {
        action: () => {
          AppUtil.isAppVersionHigherThan('3.1.0').then((res) => {
            if (res) {
              AppUtil.startDrill('sports_island_2403')
            } else {
              UIUtil.checkFailed('客户端版本过低，请升级')
            }
          })
        },
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.FruitCoin:
    case RewardType.FruitSkin:
      return {
        action: () => AppUtil.startDrill('game_fruit_master_2312'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.SportsShowSuit:
    case RewardType.SportsShowFace:
    case RewardType.SportsShowCloth:
    case RewardType.SportsShowEquip:
      return {
        action: () => AppUtil.startDrill('funsports_test_2209'),
        btnType: 'danger',
        btnLabel: '去换装',
        disabled: false,
      }

    case RewardType.BlastSkin:
    case RewardType.BlastCoin:
    case RewardType.BlastTicket:
    case RewardType.BlastTicketFire:
    case RewardType.BlastTicketTrack:
    case RewardType.BlastTicketSmall:
    case RewardType.BlastTicketFollow:
      return {
        action: () => AppUtil.startDrill('game_blast_battery_2310'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.EggPet:
    case RewardType.EggCoin:
    case RewardType.EggWeapon:
    case RewardType.EggDiamond:
    case RewardType.EggBattery:
      return {
        action: () => AppUtil.startDrill('game_pengpeng_soldier_2312'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.ParkourProp:
      return {
        action: () =>
          AppUtil.isAppVersionHigherThan('3.0.52').then((res) => {
            if (res) {
              AppUtil.startDrill('game_parkour_2401')
            } else {
              UIUtil.checkFailed('请升级版本后再跑起来吧')
            }
          }),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.DragonKnightEquip:
    case RewardType.DragonKnightDragon:
    case RewardType.DragonKnightCrystal:
    case RewardType.DragonKnightNormalEgg:
      return {
        action: () =>
          AppUtil.isAppVersionHigherThan('3.1.0').then((res) => {
            if (res) {
              AppUtil.startDrill('game_dragon_knight_2404')
            } else {
              UIUtil.checkFailed('客户端版本过低，请升级')
            }
          }),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.SuperPastrySkin:
      return {
        action: () => AppUtil.startDrill('game_super_pastry_2410'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.IslandFertilizer:
      return {
        action: () =>
          AppUtil.isAppVersionHigherThan('3.0.52').then((res) => {
            if (res) {
              AppUtil.startDrill('sports_island_2403', '', '', '', () => {}, {
                ext_infos: {
                  select_item: '13',
                },
              })
            } else {
              UIUtil.checkFailed('客户端版本过低，请升级')
            }
          }),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.MonsterExp:
    case RewardType.MonsterRole:
    case RewardType.MonsterGold:
    case RewardType.MonsterDiamond:
      return {
        action: () => AppUtil.startDrill('game_hit_monster_2510'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.AnimalKingdomExp:
    case RewardType.AnimalKingdomHero:
    case RewardType.AnimalKingdomEquip:
    case RewardType.AnimalKingdomWeapon:
    case RewardType.AnimalKingdomDiamond:
    case RewardType.AnimalKingdomGoldCoin:
    case RewardType.AnimalKingdomKingSkin:
    case RewardType.AnimalKingdomForgeBook:
    case RewardType.AnimalKingdomGoldHammer:
    case RewardType.AnimalKingdomStoneHammer:
    case RewardType.AnimalKingdomHeroFragment:
    case RewardType.AnimalKingdomRoyalLotteryTicket:
    case RewardType.AnimalKingdomNormalLotteryTicket:
      return {
        action: () => AppUtil.startDrill('game_animal_kingdom_2605'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.SquatEgg:
    case RewardType.SquatRole:
    case RewardType.SquatDiamond:
    case RewardType.SquatEggShell:
    case RewardType.SquatGoldCoin:
    case RewardType.SquatNormalTicket:
    case RewardType.SquatRoleFragment:
    case RewardType.SquatAncientTicket:
    case RewardType.SquatDefenceDiamond:
      return {
        action: () => AppUtil.startDrill('game_super_duck_2601'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.FishIslandProp:
      return {
        action: () =>
          AppUtil.startDrill('sports_island_farmland_2507', '', '', '', undefined, {
            ext_infos: { select_item: 'fish_island' },
          }),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.HungryFishProp:
    case RewardType.HungryFishDiamond:
    case RewardType.HungryFishWholeFish:
    case RewardType.HungryFishTrialCard:
      return {
        action: () => AppUtil.startDrill('game_frenzy_fish_2609'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.BigPlayHotGift:
      return {
        action: () => AppUtil.jump2NativePageByName('virtualSportRoom'),
        btnType: 'danger',
        btnLabel: '去使用',
        disabled: false,
      }

    case RewardType.ViewLogistics:
      return {
        action: () => {},
        btnType: 'function',
        btnLabel: '查看物流',
        disabled: false,
      }

    default:
      return {
        action: () => {},
        btnType: 'function',
        btnLabel: '去查看',
        disabled: true,
      }
  }
}

export function tzyRewardType2RewardType(_type: E_REWARD_ITEM_TYPE, _confirmable: boolean) {
  if (_confirmable) {
    return RewardType.ViewLogistics
  }

  switch (_type) {
    case E_REWARD_ITEM_TYPE.C_ENERGY_BEAN:
      return RewardType.Beans
    case E_REWARD_ITEM_TYPE.C_TWIST_BOTTLE:
      return RewardType.Bottle
    case E_REWARD_ITEM_TYPE.C_STAR_SHELL:
      return RewardType.ShellCoin
    // 实物
    case E_REWARD_ITEM_TYPE.TZY_MT_POINTS_PHYSICAL:
      return RewardType.Physical
    case E_REWARD_ITEM_TYPE.TZY_MP_SCHOOL_REWARD:
      return RewardType.ActivityCoin
    // 勋章
    case E_REWARD_ITEM_TYPE.MEDAL:
      return RewardType.Medal
    // 体验vip
    case E_REWARD_ITEM_TYPE.C_S_PLUS:
      return RewardType.SSplusCouponSelf
    // 运动卡
    case E_REWARD_ITEM_TYPE.C_CARD_PACKAGE:
      return RewardType.SportsCardHolder
    case E_REWARD_ITEM_TYPE.C_CARD_DIAMOND:
      return RewardType.SportsCardDiamond
    // 运动岛载具
    case E_REWARD_ITEM_TYPE.C_SPORTS_ISLAND_VEHICLE:
      return RewardType.SportsIslandVehicle
    // 运动岛
    case E_REWARD_ITEM_TYPE.C_ISLAND_FURNITURE:
      return RewardType.SportsIslandFurniture
    // 运动秀
    case E_REWARD_ITEM_TYPE.C_SUIT:
      return RewardType.SportsShowSuit
    case E_REWARD_ITEM_TYPE.C_CLOTHING:
      return RewardType.SportsShowCloth
    case E_REWARD_ITEM_TYPE.C_EQUIPMENT:
      return RewardType.SportsShowEquip
    // 切水果
    case E_REWARD_ITEM_TYPE.C_GAME_FRUIT_KNIFE:
    case E_REWARD_ITEM_TYPE.C_GAME_FRUIT_SCENE:
    case E_REWARD_ITEM_TYPE.C_GAME_FRUIT_STARFRUIT:
      return RewardType.FruitSkin
    // 爆破英雄
    case E_REWARD_ITEM_TYPE.C_BLAST_SCENE:
      return RewardType.BlastSkin
    case E_REWARD_ITEM_TYPE.C_BLAST_TICKET:
      return RewardType.BlastTicket
    case E_REWARD_ITEM_TYPE.C_BLAST_BALL_SKIN:
      return RewardType.BlastSkin
    case E_REWARD_ITEM_TYPE.C_BLAST_CANNON_SKIN:
      return RewardType.BlastSkin
    // 火枪手
    case E_REWARD_ITEM_TYPE.C_VIRTUAL_PRODUCT:
      return RewardType.EggPet
    case E_REWARD_ITEM_TYPE.C_EGG_COIN:
      return RewardType.EggCoin
    case E_REWARD_ITEM_TYPE.C_EGG_WEAPON:
      return RewardType.EggWeapon
    case E_REWARD_ITEM_TYPE.C_EGG_DIAMOND:
      return RewardType.EggDiamond
    case E_REWARD_ITEM_TYPE.C_EGG_BATTERY:
      return RewardType.EggBattery
    // 跑酷
    case E_REWARD_ITEM_TYPE.C_PARKOUR_COIN:
    case E_REWARD_ITEM_TYPE.C_PARKOUR_PROPS:
    case E_REWARD_ITEM_TYPE.C_PARKOUR_SHIELD:
      return RewardType.ParkourProp
    // 龙骑士
    case E_REWARD_ITEM_TYPE.C_DRAGON:
      return RewardType.DragonKnightDragon
    case E_REWARD_ITEM_TYPE.C_DRAGON_EGG:
      return RewardType.DragonKnightNormalEgg
    case E_REWARD_ITEM_TYPE.C_DRAGON_COIN:
    case E_REWARD_ITEM_TYPE.C_DRAGON_CRYSTAL:
      return RewardType.DragonKnightCrystal
    // 动感跳羔
    case E_REWARD_ITEM_TYPE.C_PASTRY_SKIN:
      return RewardType.SuperPastrySkin
    // 体感大作战
    case E_REWARD_ITEM_TYPE.C_ANIMAL_KINGDOM_DIAMOND:
      return RewardType.AnimalKingdomDiamond
    // 天天下蛋龙
    case E_REWARD_ITEM_TYPE.C_SUPER_DUCK_DIAMOND:
      return RewardType.SquatDiamond
    case E_REWARD_ITEM_TYPE.C_SUPER_DUCK_EGG:
      return RewardType.SquatEgg
    // 体感打怪兽
    case E_REWARD_ITEM_TYPE.C_MONSTER_BATTLE_DIAMOND:
      return RewardType.MonsterDiamond
    case E_REWARD_ITEM_TYPE.C_MONSTER_BATTLE_ROLE:
      return RewardType.MonsterRole
    // 捕鱼岛
    case E_REWARD_ITEM_TYPE.C_FISH_ISLAND_PROP:
      return RewardType.FishIslandProp
  }
}

export function rewardTypeKoiFish2RewardType(_type: RewardTypeKoiFish) {
  for (const item of Object.keys(RewardTypeKoiFish)) {
    if (RewardTypeKoiFish[item as keyof typeof RewardTypeKoiFish] === _type) {
      return RewardType[item as keyof typeof RewardTypeKoiFish]
    }
  }
}

export function useReward() {
  return {
    buildRewardBtn,
    rewardTypeKoiFish2RewardType,
  }
}
